module.exports = __webpack_public_path__ + "img/wld-wx-info.09e7135b.png";